import { NDCTableInstanceInterfce } from 'Interfaces/FactsInterfaces/drugInterfaces';
import classes from './customAccordionHeader.module.scss';

const CustomAccordionHeader = ({ headerData }: { headerData: NDCTableInstanceInterfce }) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');
  };

  return (
    <div className={classes.accordionHeaderContainer}>
      <div className={classes.headerFields}>
        <div>{`Contract : ${headerData?.ContractType}`} </div>
      </div>
      <div className={classes.headerFields}>
        <div>{`Contract Number : ${headerData?.ContractNumber}`} </div>
      </div>

      <div className={classes.headerFields}>
        <div>{`Auth Mem : ${headerData?.ReportingGroup}`} </div>
      </div>
      <div className={classes.headerFields}>
        <div>{`Term : ${formatDate(headerData?.ContractStartDate)} - ${formatDate(headerData?.ContractEndDate)}`}</div>
      </div>
    </div>
  );
};

export default CustomAccordionHeader;
